import { getMessages } from '../../../../../../../../store/constants';

export const BACKUP_CREATE_TEXT = getMessages().getText('board_settings.backup.create');
export const BACKUP_PROGRESS_TEXT = getMessages().getText('board_settings.backup.progress');
export const BACKUP_RESTORE_TEXT = getMessages().getText('board_settings.backup.restore');
export const BACKUP_RESTORE_TEXT_SHARED = getMessages().getText('board_settings.backup.restore.shared');
